import { Button } from '../Button';
import { Icon } from '../Icon';
import { Text } from '../Text';

export type LayerRowActionCellProps = {
  /** Called when the Add action is clicked. */
  onAdd?: () => void;
  className?: string;
  'data-testid'?: string;
};

/**
 * Action-column cell: the "Add" button that adds a catalog layer to the user's library.
 * Presentational — the parent decides what "add" does. Added layers leave the catalog
 * table entirely (they move to the Selected table), so there is no "added" state here.
 */
function LayerRowActionCell({ onAdd, className, 'data-testid': dataTestId }: LayerRowActionCellProps) {
  return (
    <Button
      variant="secondary"
      size="small"
      onClick={onAdd}
      className={`h-6 ${className ?? ''}`}
      data-testid={dataTestId ?? 'layer-row-add'}
    >
      <Icon icon="plus" size={14} />
      <Text className="text-xs">Add</Text>
    </Button>
  );
}

export { LayerRowActionCell };
